/**
 * Converts array to base64 hash
 *
 * @param {[]} array array to be converted to hash
 * @returns {string} Resulting hash
 */
export default function ArrayToBase64Hash(array: any[]): string {
  const arrayJSON = JSON.stringify(array);
  return Buffer.from(arrayJSON).toString("base64");
}
